
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Shivajinagartomumbaicabservice() {



    const cardData =
    {
        keyword: 'Shivajinagar to Mumbai Cab Service',
        heading: 'Meghana Cab : Shivajinagar to Mumbai Cab Service',
        headingDescription: 'Meghana Cab offers Shivajinagar to Mumbai Cab Service, delivering a smooth, safe, and punctual travel experience from Pune’s central and bustling locality to Mumbai. Whether you’re planning a business trip, airport transfer, or weekend getaway, our wide range of vehicles—Hatchbacks, Sedans, SUVs, Innova Crysta, and Tempo Travellers—ensures comfort and convenience for every traveler. Enjoy door-to-door pickups from Shivajinagar, professional drivers, transparent pricing, and 24/7 customer support. Book your Shivajinagar to Mumbai Cab with Meghana Cab and experience reliable intercity travel with complete peace of mind.',


        top: 'Top Places to Visit in Mumbai with Meghana Cab',

      "topPlaces": [ 
 
  {
    "title": "Siddhivinayak Temple",
    "description": "One of the richest and most visited temples in Mumbai, Siddhivinayak is dedicated to Lord Ganesha, the remover of obstacles. Originally built in 1801, it features a gold-plated inner sanctum and a unique idol carved from a single black stone, with the trunk curving to the right. The temple draws politicians, Bollywood celebrities, and millions of devotees annually, especially on Tuesdays when the lines stretch for hours. Despite the crowds, the spiritual atmosphere and meticulous organization make it a peaceful yet powerful experience."
  },
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most enduring symbol, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this colossal basalt arch marks the point from which the last British troops left India, making it both a historical and emotional landmark. Located in Apollo Bunder, it serves as a hub for ferry rides to Elephanta Island and provides stunning views at sunrise and sunset. The Indo-Saracenic style architecture and its vibrant surroundings filled with street vendors, photographers, and tourists make it a dynamic cultural hub."
  },
  {
    "title": "Marine Drive & Girgaon Chowpatty",
    "description": "Stretching 3.6 kilometers along the Arabian Sea, Marine Drive is Mumbai’s iconic palm-lined promenade shaped like a necklace, earning it the nickname 'Queen’s Necklace.' It’s a favorite spot for joggers, lovers, and tourists who gather to admire the sea view and city skyline, especially at sunset. At the northern end lies Girgaon Chowpatty, a lively beach known for its street food—bhel puri, pav bhaji, gola—and as a venue for the grand Ganesh Visarjan immersions. The entire stretch embodies Mumbai’s coastal spirit and urban pulse."
  },
   {
    "title": "Elephanta Caves",
    "description": "Located 11 km offshore on Elephanta Island, these 5th-to-8th-century rock-cut caves are a UNESCO World Heritage Site showcasing ancient Indian art dedicated primarily to Lord Shiva. The highlight is the massive Trimurti sculpture—depicting the three aspects of Shiva—carved into a single rock face. The island offers not just religious and artistic significance but also scenic views, lush trails, and a tranquil ferry ride from the Gateway of India, making it a full-day cultural and nature getaway from Mumbai's bustle."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "A masterpiece of Victorian Gothic Revival architecture fused with Indian design, CST (formerly Victoria Terminus) is a UNESCO World Heritage Site and one of India’s busiest railway stations. Constructed in 1887, the terminus features turrets, pointed arches, domes, stained-glass windows, and intricate carvings of animals and deities. It stands as a testament to colonial-era craftsmanship while functioning as a modern-day transport lifeline for over 3 million daily commuters. Its majestic façade is especially breathtaking when illuminated at night."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Built in 1431 in honor of the Sufi saint Haji Ali, this Indo-Islamic marble dargah sits on a tiny islet 500 meters off the coast, connected by a narrow causeway that floods during high tide. It is visited by people of all religions and backgrounds, symbolizing Mumbai’s spiritual inclusiveness. With white domes, intricate mirror work, and prayers echoing against sea winds, it offers both a religious and atmospheric experience. The view of the Mumbai skyline from the dargah adds a contemplative beauty to the site."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya (Prince of Wales Museum)",
    "description": "Housed in a grand Indo-Saracenic building amidst lush gardens, this museum features over 50,000 artifacts from ancient to modern India. Its galleries cover art, archaeology, armory, numismatics, and decorative arts, including standout collections of miniature paintings, Buddhist sculptures, Mughal weaponry, and European antiques. The museum offers guided tours, audio guides, and children's workshops, making it both educational and engaging for visitors of all ages. Its architectural grandeur and curated exhibits make it one of India’s finest museums."
  },
  {
    "title": "Colaba Causeway",
    "description": "A vibrant shopping and cultural district near the Gateway of India, Colaba Causeway offers a sensory overload of colors, sounds, and flavors. Street stalls sell everything from junk jewelry and antiques to clothing and souvenirs, while iconic cafés like Leopold and Café Mondegar cater to tourists and locals alike. It’s the perfect place to experience Mumbai’s cosmopolitan vibe, blending colonial architecture with contemporary fashion, street food, and bustling life from early morning until late night."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular coastal stretches, offering a blend of natural beauty, local flavors, and a touch of celebrity culture. Frequented by locals for evening walks, kite flying, and beachside yoga, the beach is also known for its chaat stalls, pony rides, and occasional film shoots. It's common to spot Bollywood stars residing nearby. The beach also hosts cultural festivals and public events, making it more than just a leisure destination—it’s a slice of Mumbai’s identity."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "This 87-square-kilometer green oasis within city limits offers a rare mix of wildlife sanctuary, recreational space, and ancient history. The park houses deer, leopards, monkeys, and over 250 species of birds, along with a toy train, boating lake, and nature trails. The Kanheri Caves within the park—dating from 1st century BCE to 10th century CE—are a group of over 100 Buddhist rock-cut monasteries and prayer halls. The combination of spirituality, wildlife, and open space makes it one of Mumbai’s most unique destinations."
  }
],

"services": [
    {
        "name": "Shivajinagar to Mumbai Cab Booking",
        "description": "Book a hassle-free cab from Shivajinagar to Mumbai with our reliable service. Ideal for personal travel, airport transfers, and outstation trips, we offer punctual pickups, clean vehicles, and friendly chauffeurs for a smooth travel experience."
    },
    {
        "name": "One Way Taxi Shivajinagar to Mumbai",
        "description": "Travel one-way from Shivajinagar to Mumbai without paying for the return journey. Perfect for business travel, relocations, or airport drops, our one-way taxi service is cost-effective, efficient, and comfortable."
    },
    {
        "name": "Round Trip Shivajinagar to Mumbai Cab",
        "description": "Need a return cab? Our round-trip taxi service between Shivajinagar and Mumbai is perfect for short business visits or leisure trips. Enjoy flexible return timings, the same driver throughout, and great package deals."
    },
    {
        "name": "Budget Cab Shivajinagar to Mumbai",
        "description": "Looking for an affordable option? Our budget cabs from Shivajinagar to Mumbai offer the best balance of price and comfort. Get clean, well-maintained cars and trained drivers at economical rates."
    },
    {
        "name": "Online Taxi Hire Shivajinagar to Mumbai",
        "description": "Book your Shivajinagar to Mumbai taxi online with ease. Our intuitive platform provides instant confirmations, fare transparency, and multiple vehicle choices, making online booking quick and secure."
    },
    {
        "name": "SUV Cab Shivajinagar to Mumbai",
        "description": "Travel with extra space and comfort in our SUVs. Ideal for families, groups, or luggage-heavy trips, our SUV taxi service from Shivajinagar to Mumbai offers superior comfort for long-distance journeys."
    },
    {
        "name": "Sedan Cab Shivajinagar to Mumbai",
        "description": "Choose our sedan cabs for a sleek, smooth ride from Shivajinagar to Mumbai. Sedans are perfect for solo travelers, couples, or business professionals looking for style and comfort."
    },
    {
        "name": "Private Cab Shivajinagar to Mumbai",
        "description": "Enjoy exclusive travel with our private cab hire. No sharing, no delays—just a peaceful, direct ride from Shivajinagar to Mumbai tailored to your schedule and preferences."
    },
    {
        "name": "Corporate Cab Shivajinagar to Mumbai",
        "description": "Our corporate cab service offers prompt and professional transportation from Shivajinagar to Mumbai. Ideal for meetings, airport runs, or executive travel with GST invoicing and priority support."
    },
    {
        "name": "Chauffeur Driven Taxi Shivajinagar to Mumbai",
        "description": "Travel with elegance in our chauffeur-driven taxis. Courteous drivers, clean interiors, and a relaxed ride make this service from Shivajinagar to Mumbai ideal for business guests or special occasions."
    },
    {
        "name": "Fast Booking Shivajinagar to Mumbai Cab",
        "description": "Need a quick cab? Our fast booking system helps you reserve a Shivajinagar to Mumbai taxi in minutes. Choose from multiple cars, get instant confirmation, and track your cab in real time."
    },
    {
        "name": "Family Cab Shivajinagar to Mumbai",
        "description": "Going to Mumbai with your family? Our family-friendly cabs offer spacious interiors, child safety options, and experienced drivers who ensure a pleasant journey for all age groups."
    },
    {
        "name": "Reliable Cab Shivajinagar to Mumbai",
        "description": "Count on us for a reliable taxi service from Shivajinagar to Mumbai. With verified drivers, real-time tracking, and customer support, we ensure a dependable experience every time you book."
    },
    {
        "name": "Shivajinagar to Mumbai AC Taxi",
        "description": "Beat the heat with our air-conditioned taxi service from Shivajinagar to Mumbai. Our AC cabs guarantee a cool, comfortable, and fatigue-free journey for any time of day."
    },
    {
        "name": "24/7 Shivajinagar to Mumbai Cab",
        "description": "Book a cab from Shivajinagar to Mumbai anytime, day or night. Our 24/7 availability ensures that you’ll always have a ride—whether it’s early morning airport travel or a late-night return."
    }
],
"tableData": [
    ["Shivajinagar to Mumbai Cab Booking", "One Way Taxi Shivajinagar to Mumbai"],
    ["Round Trip Shivajinagar to Mumbai Cab", "Budget Cab Shivajinagar to Mumbai"],
    ["Online Taxi Hire Shivajinagar to Mumbai", "SUV Cab Shivajinagar to Mumbai"],
    ["Sedan Cab Shivajinagar to Mumbai", "Private Cab Shivajinagar to Mumbai"],
    ["Corporate Cab Shivajinagar to Mumbai", "Chauffeur Driven Taxi Shivajinagar to Mumbai"],
    ["Fast Booking Shivajinagar to Mumbai Cab", "Family Cab Shivajinagar to Mumbai"],
    ["Reliable Cab Shivajinagar to Mumbai", "Shivajinagar to Mumbai AC Taxi"],
    ["24/7 Shivajinagar to Mumbai Cab", ""]
],





"whychoose": [
    {
        "WhyChooseheading": "Dependable Shivajinagar to Mumbai Cab Service",
        "WhyChoosedescription": "Our cab service from Shivajinagar to Mumbai is designed for travelers who value punctuality, comfort, and professionalism. Whether you're commuting for business, catching a flight, or planning a leisure trip, our reliable cabs ensure timely pickups and smooth rides, eliminating the stress of intercity travel."
    },
    {
        "WhyChooseheading": "Comfortable, Clean, and Well-Maintained Fleet",
        "WhyChoosedescription": "We maintain a fleet of air-conditioned vehicles ranging from budget hatchbacks to premium sedans and spacious SUVs. Each vehicle is thoroughly cleaned before every ride, regularly serviced, and equipped with plush seating and ample luggage space, so you can enjoy a peaceful and comfortable journey regardless of travel duration."
    },
    {
        "WhyChooseheading": "Trained, Courteous, and Verified Drivers",
        "WhyChoosedescription": "All our drivers are background-verified, professionally trained, and have extensive experience on the Shivajinagar to Mumbai route. They follow safety guidelines, maintain a courteous demeanor, and prioritize your comfort and timely arrival. Their familiarity with alternate routes also helps avoid traffic bottlenecks during peak hours."
    },
    {
        "WhyChooseheading": "Transparent and Budget-Friendly Pricing",
        "WhyChoosedescription": "Our pricing is upfront and all-inclusive—covering fuel, tolls, taxes, and driver allowances. There are no hidden fees or last-minute surprises. Whether you're a daily commuter or planning a one-time trip, our competitive rates ensure excellent value without compromising on service quality."
    },
    {
        "WhyChooseheading": "Flexible Booking Options Tailored to Your Schedule",
        "WhyChoosedescription": "We understand that every traveler has unique needs. That's why we offer one-way trips, round trips, hourly rentals, and custom packages. With the ability to choose your pickup/drop location, departure time, and vehicle type, you can design a travel plan that fits your personal or professional commitments perfectly."
    },
    {
        "WhyChooseheading": "Convenient Door-to-Door Pickup and Drop-off",
        "WhyChoosedescription": "Say goodbye to long walks and inconvenient transport links. Our cab will arrive right at your doorstep in Shivajinagar and drop you off at your exact destination in Mumbai—be it a home, hotel, office, or airport. It’s direct, stress-free travel from start to finish."
    },
    {
        "WhyChooseheading": "Perfect for Airport Transfers, Business Travel & Personal Trips",
        "WhyChoosedescription": "Whether you're heading to Mumbai International Airport, attending a corporate meeting, or visiting family, our cab service offers the flexibility and professionalism required for every type of traveler. Enjoy peace of mind with timely service, experienced drivers, and travel-ready vehicles."
    },
    {
        "WhyChooseheading": "24/7 Customer Support and Booking Assistance",
        "WhyChoosedescription": "Our dedicated support team is available round-the-clock to assist with bookings, changes, cancellations, and special requests. Whether you’re booking at midnight or need on-road support, we’re just a call or click away to make sure your journey is smooth and stress-free."
    }
]



























    }

const faqData = [
    {
        question: "How can I book a cab from Shivajinagar to Mumbai?",
        answer: "You can easily book your cab by calling Meghana Cab at +91 9075462128 or through our website for instant confirmation."
    },
    {
        question: "What is the estimated travel time from Shivajinagar to Mumbai?",
        answer: "The journey typically takes around 3 to 4 hours, depending on traffic and road conditions."
    },
    {
        question: "Are one way and round trip options available for Shivajinagar to Mumbai cab service?",
        answer: "Yes, we offer both one way and round trip options to match your travel needs."
    },
    {
        question: "What kinds of vehicles are available for this route?",
        answer: "We offer hatchbacks, sedans, SUVs, and tempo travellers based on your preference and group size."
    },
    {
        question: "Is the cab service available 24/7 from Shivajinagar to Mumbai?",
        answer: "Yes, our service is available round the clock, including early morning and late-night trips."
    },
    {
        question: "Is the fare inclusive of tolls, fuel, and driver charges?",
        answer: "Yes, the fare covers fuel, tolls, and driver fees. Additional charges may apply for extra stops or waiting time."
    },
    {
        question: "Can I book a cab at the last minute from Shivajinagar?",
        answer: "Yes, last-minute bookings are welcome based on availability. For immediate service, it’s best to call us."
    },
    {
        question: "Can I book the cab online for this route?",
        answer: "Yes, online booking is available 24/7 with secure payment and instant confirmation."
    },
    {
        question: "Are meal or rest stops allowed during the journey?",
        answer: "Yes, you can request short stops for meals or breaks. Please inform us in advance or let the driver know."
    },
    {
        question: "Are the drivers trained and familiar with the Shivajinagar to Mumbai route?",
        answer: "Absolutely. All our drivers are experienced, courteous, and well-versed with this route."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Pravin Deshmukh',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Reliable and professional cab service from Shivajinagar to Mumbai. The booking process was quick and simple.”',
    },
    {
        name: 'Ms. Anuja Satpute',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Clean car, polite driver, and on-time service. Meghana Cab is my go-to for trips from Shivajinagar to Mumbai.”',
    },
];

























































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Shivajinagar to Mumbai Cab Service",
  "image": "https://www.meghanacabs.com/assets/images/shivajinagar-to-mumbai-cab.jpg",
  "description": "Book reliable and affordable cab service from Shivajinagar to Mumbai with Meghana Cabs. Choose from AC Sedans, SUVs, and chauffeur-driven cars. Available 24/7 for one-way and round trips with easy online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5213"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1899",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/shivajinagar-to-mumbai-cab-service"
  }
};






    return (
        <div>

<Helmet>
  <title>Shivajinagar to Mumbai Cab Service | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Affordable and reliable cab service from Shivajinagar to Mumbai by Meghana Cabs. Book AC Sedans, SUVs, and chauffeur-driven cars online. Available 24/7 for one-way and round trip travel." 
  />
  <meta 
    name="keywords" 
    content="Shivajinagar to Mumbai Cab Booking, One Way Taxi Shivajinagar to Mumbai, Round Trip Shivajinagar to Mumbai Cab, Budget Cab Shivajinagar to Mumbai, Online Taxi Hire Shivajinagar to Mumbai, SUV Cab Shivajinagar to Mumbai, Sedan Cab Shivajinagar to Mumbai, Private Cab Shivajinagar to Mumbai, Corporate Cab Shivajinagar to Mumbai, Chauffeur Driven Taxi Shivajinagar to Mumbai, Fast Booking Shivajinagar to Mumbai Cab, Family Cab Shivajinagar to Mumbai, Reliable Cab Shivajinagar to Mumbai, Shivajinagar to Mumbai AC Taxi, 24/7 Shivajinagar to Mumbai Cab" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/66.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Shivajinagartomumbaicabservice;